export const redirectInNewTab = async ({
  getUrl,
  onError,
}: {
  getUrl: () => Promise<string | undefined>;
  onError: () => void;
}) => {
  const newWindow = window.open('', '_blank');
  if (!newWindow) {
    onError();
    return;
  }
  try {
    const url = await getUrl();
    if (url) {
      newWindow.opener = null;
      newWindow.location.href = url;
    } else {
      newWindow.close();
      onError();
    }
  } catch (e) {
    newWindow.close();
    onError();
  }
};
